export default "__VITE_ASSET__bYXkIbpK__"